// src/layouts/authentication/sign-in/index.js

import { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";

import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import IconImage from "assets/images/favicon.png";
import AuthContext from "context/AuthContext";
import { keyframes } from "@emotion/react";

const cardEntrance = keyframes`
  from { opacity: 0; transform: translateY(30px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, error } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {}
  };

  return (
    <CoverLayout image={bgImage}>
      <Card
        sx={{
          animation: `${cardEntrance} 0.6s ease-out both`,
          transition: "box-shadow 0.3s ease",
          "&:hover": { boxShadow: "0 12px 35px rgba(0,0,0,0.12)" },
        }}
      >
        <MDBox
          variant="gradient"
          bgColor="purple"
          borderRadius="lg"
          coloredShadow="purple"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDBox display="flex" alignItems="center" justifyContent="center" sx={{ mb: 1 }}>
            <MDBox component="img" src={IconImage} alt="Logo" width="40px" sx={{ mr: 1.5 }} />
            <MDTypography variant="h5" fontWeight="bold" color="white" sx={{ letterSpacing: 1 }}>
              {process.env.REACT_APP_BRAND_NAME}
            </MDTypography>
          </MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={2}>
            Connexion
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Mot de passe"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Se souvenir de moi
              </MDTypography>
            </MDBox>
            {error && (
              <MDBox mt={2}>
                <MDTypography variant="button" color="error">
                  {error}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="purple" fullWidth type="submit">
                Se connecter
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Mot de passe oublié ?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/forgot-password"
                  variant="button"
                  color="purple"
                  fontWeight="medium"
                  textGradient
                >
                  Réinitialisation
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Basic;
